import { DevConsole } from "./flags.js";
import "./performance_logs.js";
import "../persist/persist.js";
import "../global-33d5eebf.js";
import "./editor.js";
import "../components/ComponentRegistry.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../enums-86f58524.js";
import "../components/types.js";
import "../utils/byteArray.js";
import "./floatingwindow.js";
import "lodash";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
DevConsole();
//# sourceMappingURL=preload.js.map
